import instance from "./instance";
import {API_URL} from "../config/api";

export default class CADService {

    static create = async (params) => {
        const res = await instance.post(API_URL.CAD_SERVICE, params);
        // console.log(res);
        try {
            if (res.status === 200) {
                return res.data.data.result;
            }
        } catch (e) {
            console.error(e);
        }
    }
}